module.exports = __webpack_public_path__ + "img/home4.5d848d89.png";